import {
  TransportationMode,
  TransportationModeValues,
} from '@/domain/impact-co2/entities/question.entity';
import {
  AccommodationType,
  AccommodationTypeValues,
} from '@/domain/impact-co2/entities/question.entity';
import { ImpactCo2AnswerStatsPublic } from '@/domain/impact-stats/entities/stats-public.entity';
import { validateValueInType } from '@/domain/utils/validate-value-in-type';

import { StatsPublicDto } from './stats-public.dto';

export class StatsPublicMapper {
  static dtoToEntity(dto: StatsPublicDto): ImpactCo2AnswerStatsPublic {
    return {
      publicMobility: dto.publicMobility.map((x) => ({
        transportationMode: validateValueInType<TransportationMode>(
          x.transportationMode,
          TransportationModeValues,
        ),
        totalPassengerCount: Number.parseFloat(
          x.totalPassengerCount.toString(),
        ),
        totalTravelDistance: Number.parseFloat(
          x.totalTravelDistance.toString(),
        ),
        totalScore: x.totalScore,
      })),
      publicAccommodation: dto.publicAccommodation.map((x) => ({
        accommodationType: validateValueInType<AccommodationType>(
          x.accommodationType,
          AccommodationTypeValues,
        ),
        totalGuestCount: Number.parseFloat(x.totalGuestCount.toString()),
        totalNumberOfNights: Number.parseFloat(
          x.totalNumberOfNights.toString(),
        ),
        totalScore: x.totalScore,
      })),
      averageNumberOfNights: Number.parseFloat(
        dto.averageNumberOfNights.toString(),
      ),
      numberOfNights: Number.parseFloat(dto.numberOfNights.toString()),
      publicMobilityTotalReplies: computeMobilityTotalReplies(dto),
      publicMobilitySumTotalTravelDistance: computeSumTotalTravelDistance(dto),
      publicMobilitySumTotalPassengerCount: computeSumTotalPassengerCount(dto),
      publicAccommodationTotalReplies: computeAccommodationTotalReplies(dto),
      publicAccommodationSumTotalGuestCount: computeSumTotalGuestCount(dto),
    };
  }
}

function computeMobilityTotalReplies(dto: StatsPublicDto): number {
  return dto.publicMobility.reduce(
    (acc, x) => acc + parseInt(x.replies, 10),
    0,
  );
}

function computeAccommodationTotalReplies(dto: StatsPublicDto): number {
  return dto.publicAccommodation.reduce(
    (acc, x) => acc + parseInt(x.replies, 10),
    0,
  );
}

function computeSumTotalTravelDistance(dto: StatsPublicDto): number {
  return dto.publicMobility.reduce(
    (acc, x) => acc + parseInt(x.totalTravelDistance, 10),
    0,
  );
}

function computeSumTotalPassengerCount(dto: StatsPublicDto): number {
  return dto.publicMobility.reduce(
    (acc, x) => acc + parseInt(x.totalPassengerCount, 10),
    0,
  );
}

function computeSumTotalGuestCount(dto: StatsPublicDto): number {
  return dto.publicAccommodation.reduce(
    (acc, x) => acc + parseInt(x.totalGuestCount, 10),
    0,
  );
}
